import { useState } from "react";
import { Link } from "react-router-dom";
import { faqList } from "@/mocks/home";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 scroll-mt-20">
      <div className="max-w-content mx-auto w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs md:text-sm font-medium text-primary-600 tracking-wide">
              FAQ / 常见问题
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              你可能想知道的
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              关于内容整理方式、更新机制与信息核对，这里给出了集中说明。还有其他疑问，欢迎通过联系表单告诉我们。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors"
            >
              查看完整问答
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-lg border border-background-200 bg-background-100 divide-y divide-background-200 overflow-hidden">
              {faqList.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.question}>
                    <button
                      onClick={() => setOpen(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-background-200/50 transition-colors"
                    >
                      <span className="font-heading text-sm md:text-base font-bold text-foreground-900">
                        {f.question}
                      </span>
                      <span
                        className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 -mt-1">
                        <p className="text-sm text-foreground-600 leading-relaxed">{f.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}